/**
 * Format- und Uebersetzungshelfer der Ticket-Detailansicht -- #470 (Scheibe 1
 * aus #310).
 *
 * Die Funktionen standen woertlich so in TicketDetail.js. Wie bei
 * kalenderHelfer.js (#311) kommt der Kontext als Parameter herein: die Sprache
 * fuer formatDate, die Uebersetzungsfunktion t fuer translateStatus und
 * translatePriority. Die Komponente nimmt erstelleTicketFormat({ t, getLocale })
 * und bekommt dieselben Funktionen mit gebundenem Kontext -- ihre Aufrufstellen
 * bleiben unveraendert.
 */

export const formatDate = (dateString, locale) => {
  const date = new Date(dateString);
  return date.toLocaleString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const cleanPreviewText = (text, maxLength = 200) => {
  if (!text) return '';
  
  // Entferne HTML-Tags und CID-Referenzen für die Vorschau
  let cleanText = text
    .replace(/<[^>]*>/g, '') // Entferne HTML-Tags
    .replace(/cid:[^"'\s>]+/gi, '[Bild]') // Ersetze CID-Referenzen durch [Bild]
    .replace(/\s+/g, ' ') // Normalisiere Leerzeichen
    .trim();
  
  if (cleanText.length <= maxLength) return cleanText;
  return cleanText.substring(0, maxLength) + '...';
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'offen': return 'var(--color-status-offen)';
    case 'in_bearbeitung': return 'var(--color-status-in-bearbeitung)';
    case 'wartend': return 'var(--color-status-wartend)';
    case 'abgeschlossen': return 'var(--color-status-abgeschlossen)';
    default: return 'var(--color-status-unbekannt)';
  }
};

export const getPriorityColor = (priority) => {
  switch (priority) {
    case 'niedrig': return 'var(--color-prio-niedrig)';
    case 'hoch': return 'var(--color-prio-hoch)';
    case 'kritisch': return 'var(--color-prio-kritisch)';
    default: return 'var(--color-prio-unbekannt)';
  }
};

export const translateStatus = (status, t) => {
  switch ((status || '').toLowerCase()) {
    case 'offen':
      return t('ticket.status.open', 'Offen');
    case 'in_bearbeitung':
      return t('ticket.status.in_progress', 'In Bearbeitung');
    case 'wartend':
      return t('ticket.status.waiting', 'Wartend');
    case 'zugewiesen':
      return t('ticket.status.assigned', 'Zugewiesen');
    case 'abgeschlossen':
      return t('ticket.status.completed', 'Abgeschlossen');
    default:
      return status || '';
  }
};

export const translatePriority = (priority, t) => {
  switch ((priority || '').toLowerCase()) {
    case 'niedrig':
      return t('ticket.priority.low', 'Niedrig');
    case 'normal':
      return t('ticket.priority.normal', 'Normal');
    case 'hoch':
      return t('ticket.priority.high', 'Hoch');
    case 'kritisch':
      return t('ticket.priority.critical', 'Kritisch');
    default:
      return priority || '';
  }
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

/**
 * Dieselben Funktionen mit gebundenem Kontext. getLocale wird wie vorher erst
 * beim Aufruf gefragt, nicht beim Erzeugen.
 */
export const erstelleTicketFormat = ({ t, getLocale }) => ({
  formatDate: (dateString) => formatDate(dateString, getLocale()),
  cleanPreviewText,
  getStatusColor,
  getPriorityColor,
  translateStatus: (status) => translateStatus(status, t),
  translatePriority: (priority) => translatePriority(priority, t),
  formatFileSize
});
